/**
 * Hook to load pre-fetched Algolia data from build time
 * Falls back to empty array if data is not available
 */

import { useEffect, useState } from "react";

const isBrowser = typeof window !== "undefined";

const usePrefetchedData = (dataType) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadPrefetchedData = async () => {
      try {
        if (!isBrowser) {
          setIsLoading(false);
          return;
        }

        // Map data types to file paths
        const dataFileMap = {
          articles: "/prefetched/latest-articles.json",
          brands: "/prefetched/brands.json",
          products: "/prefetched/products.json"
        };

        const filePath = dataFileMap[dataType];
        if (!filePath) {
          console.warn(`Unknown data type: ${dataType}`);
          setIsLoading(false);
          return;
        }

        const response = await fetch(filePath);
        if (response.ok) {
          const prefetchedData = await response.json();
          setData(Array.isArray(prefetchedData) ? prefetchedData : []);
        } else {
          // File doesn't exist - that's OK, components will use dynamic queries
          setData([]);
        }
      } catch (error) {
        console.debug(`Could not load prefetched ${dataType}:`, error.message);
        setData([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadPrefetchedData();
  }, [dataType]);

  return { data, isLoading };
};

export default usePrefetchedData;
